import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-secondary/40 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-background border border-border rounded-sm p-8">
        <Link to="/login" className="inline-flex items-center text-xs text-muted-foreground hover:text-foreground mb-6">
          <ArrowLeft className="w-3 h-3 mr-1" /> Back to sign in
        </Link>
        <h1 className="font-display text-3xl font-black tracking-tighter">Forgot password?</h1>
        <p className="text-sm text-muted-foreground mt-2 mb-6">
          Enter your email and we&apos;ll send you a reset link. The link is valid for 24 hours.
        </p>
        {sent ? (
          <div className="border border-success/40 bg-success/10 rounded-sm p-4 text-sm" data-testid="forgot-sent">
            <div className="flex items-center gap-2 font-semibold text-success">
              <Mail className="w-4 h-4" /> Check your inbox
            </div>
            <p className="text-muted-foreground mt-1">
              If an account exists for <strong>{email}</strong>, we just emailed you a reset link.
            </p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="forgot-email">Email</Label>
              <Input id="forgot-email" type="email" required value={email}
                     onChange={(e) => setEmail(e.target.value)}
                     className="rounded-sm h-11" autoFocus data-testid="forgot-email-input" />
            </div>
            <Button type="submit" disabled={busy} className="w-full rounded-sm h-11" data-testid="forgot-submit-button">
              {busy ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
